<ng-container *ngFor="let c of children; let i = index">

    <div class="mw-100 p-1" [ngClass]="{
        'col': c.size===0 || c.size==='0',
        'w-100': c.size=='12',
        'col-lg-11': c.size=='11',
        'col-lg-10': c.size=='10',
        'col-lg-9': c.size=='9',
        'col-lg-8': c.size=='8',
        'col-lg-7': c.size=='7',
        'col-lg-6': c.size=='6',
        'col-lg-5': c.size=='5',
        'col-lg-4': c.size=='4',
        'col-lg-3': c.size=='3',
        'col-lg-2': c.size=='2',
        'col-lg-1': c.size=='1',
        'col-sm-6': c.size == '1' || c.size == '2' || c.size == '3' || c.size == '4'
    }">

        <div [ngClass]="c.class">
            <app-card-collapse cardBodyClass="px-lg-2 pt-lg-2 pb-3 p-1" class="w-100 mb-3 mb-lg-4 d-block"
                *ngIf="c.type=='card-collapse'" [title]="c.label">
                <app-element-template-builder *ngIf="c.element && elements[c.element]" [element]="getElement(c.element)"
                    [preview]="getElementPreview(c.element)">
                </app-element-template-builder>

                <app-template-builder [children]="c.children" [elements]="elements"></app-template-builder>

            </app-card-collapse>

            <div *ngIf="c.type!='card-collapse'" class="w-100" [ngClass]="[c.type]">
                <div *ngIf="c.label && (c.type == 'card' || c.type == 'sub-card') && !c.element"
                    class="bg-o-primary p-2 fw-500">{{c.label}}</div>
                <div class="p-1">
                    <app-element-template-builder *ngIf="c.element && elements[c.element]"
                        [element]="getElement(c.element)" [templateLabel]="c.label"
                        [preview]="getElementPreview(c.element)">
                    </app-element-template-builder>
                    <app-template-builder [children]="c.children" [elements]="elements"></app-template-builder>
                </div>
            </div>
        </div>
    </div>
</ng-container>